var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1C0.5 0.867392 0.552678 0.740215 0.646447 0.646447C0.740215 0.552678 0.867392 0.5 1 0.5H13C13.1326 0.5 13.2598 0.552678 13.3536 0.646447C13.4473 0.740215 13.5 0.867392 13.5 1V3C13.5 3.12331 13.4544 3.24226 13.372 3.334L9 8.192V13C8.99992 13.1049 8.96685 13.2071 8.90547 13.2922C8.8441 13.3772 8.75752 13.4409 8.658 13.474L5.658 14.474C5.58287 14.499 5.50288 14.5058 5.4246 14.4939C5.34632 14.482 5.272 14.4516 5.20775 14.4053C5.1435 14.359 5.09116 14.2982 5.05504 14.2277C5.01893 14.1572 5.00006 14.0792 5 14V8.192L0.628 3.334C0.545608 3.24226 0.500022 3.12331 0.5 3V1ZM1.5 1.5V2.808L5.872 7.666C5.95439 7.75774 5.99998 7.87669 6 8V13.306L8 12.64V8C8.00002 7.87669 8.04561 7.75774 8.128 7.666L12.5 2.808V1.5H1.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconLight);
export default __webpack_public_path__ + "static/media/filterIconLight.2aa34b0f0f7111fce569369cffadf3be.svg";
export { ForwardRef as ReactComponent };